import { FC, memo } from 'react';
import { Button } from 'shared/ui';
import styles from './EmptyState.module.scss';

interface EmptyStateProps {
  message: string;
  icon?: string;
  description?: string;
  onCreateNew?: () => void;
  createButtonText?: string;
}

export const EmptyState: FC<EmptyStateProps> = memo(({
  message,
  icon = '📋',
  description,
  onCreateNew,
  createButtonText = 'Создать',
}) => (
  <div className={styles.emptyState}>
    <div className={styles.emptyStateContent}>
      <div className={styles.emptyStateIcon}>
        {icon}
      </div>
      <h3 className={styles.emptyStateTitle}>
        {message}
      </h3>
      {description && (
        <p className={styles.emptyStateDescription}>
          {description}
        </p>
      )}
      {onCreateNew && (
        <Button
          onClick={onCreateNew}
          className={styles.createButton}
        >
          {createButtonText}
        </Button>
      )}
    </div>
  </div>
));

EmptyState.displayName = 'EmptyState';
